module.exports = __webpack_public_path__ + "img/icon_group.bf92770c.svg";